import { takeLatest, put, select, call } from 'redux-saga/effects';

import quoteItemService from 'modules/quotes/quoteItems/data/service';
import { UPDATE_COMPONENT_SUCCESS } from 'modules/quotes/quoteItems/data/types';

import { livePricingPreview, types } from './actions';
import {
  getCurrentOverrides,
  getIsOperationModalOpen,
  getOperationId,
} from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_OPERATION_MODAL, watchOpenOperationModal);
  yield takeLatest(
    types.LIVE_PRICING_PREVIEW_REQUEST,
    watchLivePricingPreviewRequest,
  );
  yield takeLatest(UPDATE_COMPONENT_SUCCESS, watchUpdateComponentSuccess);
  yield takeLatest(types.RECEIVE_OVERRIDES, watchReceiveOverrides);
}

function* watchOpenOperationModal(action) {
  const { payload } = action;
  const { operation } = payload;
  yield put(livePricingPreview.request(operation.id, operation.overrides));
}

function* watchReceiveOverrides(action) {
  const { payload } = action;
  const { nextOverrides } = payload;
  const operationId = yield select(getOperationId);
  yield put(livePricingPreview.request(operationId, nextOverrides));
}

function* watchLivePricingPreviewRequest(action) {
  try {
    const { payload } = action;
    const { operationId, overrides } = payload;
    const response = yield call(
      quoteItemService.operations.livePricing,
      operationId,
      { overrides },
    );
    yield put(livePricingPreview.success(response));
  } catch (error) {
    console.error(error);
    yield put(livePricingPreview.error);
  }
}

function* watchUpdateComponentSuccess() {
  const operationId = yield select(getOperationId);
  const operationOverrides = yield select(getCurrentOverrides);
  const isOpen = yield select(getIsOperationModalOpen);
  if (isOpen)
    yield put(livePricingPreview.request(operationId, operationOverrides));
}
